import { connect } from "react-redux";

import { FullFormState } from "../../Engine/Core/Store/FullFormState";
import { reject } from "../../../../Common/TypingUtils";
import { CandyDispatch } from "../../Engine/Core/Store/CandyReduxTypes";
import { GetContractorResponse } from "../Types/ContractorsTypes";
import { cancelImportContractors, importContractors } from "../State/ContractorsActionCreators";

import { ContractorsSidePage } from "./ContractorsSidePage";

const mapStateToProps = (state: FullFormState) => ({
    active: state.contractors?.showSideBar ?? false,
    options: state.contractors?.options,
    contractorsWidgetUrl: state.settings.contractorsWidgetUrl ?? reject("contractorsWidgetUrl must be defined"),
    gfv: state.settings.gfv,
});

const mapDispatchToProps = (dispatch: CandyDispatch) => ({
    onClose: () => dispatch(cancelImportContractors()),
    onSubmit: (contractors: GetContractorResponse[]) => dispatch(importContractors(contractors)),
});

export const ContractorsSidePageContainer = connect(mapStateToProps, mapDispatchToProps)(ContractorsSidePage);
